import React from 'react';
import { handleDownloadTxt } from '../Helpers/CommonHelpers';

const ConversionActions = ({
  tabSpace,
  setTabSpace,
  handleConversion,
  outputData,
  randomPost,
  loadingPost,
  handleBlogClick
}) => {
  return (
    <div
      className="full-col col-lg-2 col-md-2"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <div
        className="single-blog-inner"
        data-aos="fade-up"
        data-aos-duration="2800"
      >
        <div
          className="thumb"
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          {/* Tab Space Selector */}
          <div className="pb-20 form-group">
            <select
              id="tabSpace"
              value={tabSpace}
              onChange={(e) => setTabSpace(Number(e.target.value))}
              className="form-control"
              style={{
                display: 'flex',
                flexDirection: 'column',
                width: '60%',
                margin: '0 auto',
              }}
            >
              <option value={2}>2 Spaces</option>
              <option value={3}>3 Spaces</option>
              <option value={4}>4 Spaces</option>
            </select>
          </div>

          {/* Convert Button */}
          <div className="pb-20">
            <button
              type="button"
              className="default-btn icon four"
              onClick={handleConversion}
            >
              <i className="ri-exchange-line"></i>
              Convert
            </button>
          </div>

          {/* Download Button */}
          <div className="pb-20">
            <button
              type="button"
              className="default-btn icon four"
              onClick={() => handleDownloadTxt(outputData)}
            >
              <i className="ri-download-line"></i>
              Download
            </button>
          </div>

          {/* Random Blog Preview */}
          <div className="pb-20">
            <div className="blogs-container">
              <div className="blog-card">
                {loadingPost || !randomPost ? (
                  <div className="blog-placeholder"></div>
                ) : (
                  <a
                    href={`/blog/${randomPost.paramlink}`}
                    className="no-underline"
                    onClick={handleBlogClick}
                  >
                    <img
                      src={randomPost.mediapath}
                      alt="Random Post"
                      className="blog-image"
                      width="176"
                      height="99"
                    />
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Random Blog Title */}
          <div className="pb-20">
            {randomPost?.title && (
              <a href={`/blog/${randomPost.paramlink}`} onClick={handleBlogClick}>
                <div className="blog-title">{randomPost.title}</div>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConversionActions;
